<template>
    <!-- 新增用户组 -->
    <a-modal
      :title="defaultVal ? '修改用户' : '新增用户'"
      :visible="visible"
      :confirmLoading="confirmLoading"

      okText="提交"
      cancelText="取消"
      @ok="handlerSubmit"
      @cancel="() => $emit('hideModal')"

      :afterClose="afterHideEditModal"
    > 
      <a-form-model 
        ref="userForm"
        :model="userForm" 
        :rules="userFormRules"
        :label-col="{ span: 6 }" 
        :wrapper-col="{ span: 18 }" 
      > 
        <a-form-model-item 
          v-if="!userForm.id"
          required label="登录账号" prop="loginName"
        >
          <a-input 
            v-model="userForm.loginName"
            placeholder="请填写用户登录账号"
          />
        </a-form-model-item>
        <a-form-model-item 
          v-if="!userForm.id"
          required label="登录密码" prop="password"
        >
          <a-input-password
            type="password" 
            :maxLength="20"
            autocomplete="new-password"
            v-model="userForm.password"            
            placeholder="请填写用户登录密码"
          />
        </a-form-model-item>
        <a-form-model-item required label="用户名称" prop="userName">
          <a-input 
            v-model="userForm.userName"
            placeholder="请填写用户名称"
          />
        </a-form-model-item>
        <a-form-model-item label="证件号" prop="idNumber">
          <a-input
            v-model="userForm.idNumber"
            placeholder="请填写证件号"
          />
        </a-form-model-item>
        <a-form-model-item label="手机号" prop="phone">
          <a-input
            v-model="userForm.phone"
            placeholder="请填写手机号"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
</template>

<script>
const userForm = { 
  loginName: undefined, password: '12345678', 
  userName: undefined, idNumber: undefined, phone: undefined
}
const userFormRules = { 
  loginName: [{ required: true, message: '请填写用户登录账号！' }],
  password: [
    { required: true, message: '请填写用户登录密码！' },
    { min: 8, message: '登录密码最少 8 位！' }
  ],
  userName: [{ required: true, message: '请填写用户名称！' }] 
}

export default {
  name: 'EditUserModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    defaultVal: {
      type: Object,
      default: () => null
    }
  },
  data () {
    return {
      userForm,
      userFormRules,

      confirmLoading: false
    }
  },
  computed: {},
  watch: {
    defaultVal: function(data) {
      this.$nextTick(() => {
        if (data && this.visible) { this.userForm = { ...data } }
      })
    }
  },
  methods: {
    // 提交模态框数据
    handlerSubmit() {
      this.$refs.userForm.validate(async valid => {
        if (valid) {
          this.$emit('submit', this.userForm)
          this.confirmLoading = true
        }
      })
    },
    // 编辑用户组模态框关闭后，重置相关数据
    afterHideEditModal() {
      this.$refs.userForm.resetFields()
      this.userForm = userForm
      this.confirmLoading = false
    }
  }
}
</script>

<style>
</style>
